import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../ui/Logo";
import { spring } from "../../utils/motion";
const groups = [{
  title: "Product",
  links: [{
    to: "/pricing",
    label: "Pricing"
  }, {
    to: "/app",
    label: "Open the app"
  }, {
    to: "/app/translate",
    label: "Translator"
  }]
}, {
  title: "Company",
  links: [{
    to: "/about",
    label: "About"
  }, {
    to: "/contact",
    label: "Contact"
  }, {
    to: "/faq",
    label: "FAQ"
  }]
}, {
  title: "Legal",
  links: [{
    to: "/terms",
    label: "Terms"
  }, {
    to: "/privacy",
    label: "Privacy"
  }]
}];
export function SiteFooter() {
  return <footer className="border-t-3 border-line bg-surface" data-id="element-548" data-mp="1go1478errrqn">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-12 md:grid-cols-[1.4fr_repeat(3,1fr)] md:px-8" data-id="element-549" data-mp="18tv5hxykblf">
        <div data-id="element-550" data-mp="5aoy0qvjex1b">
          <Logo data-id="element-551" data-mp="5b8fk6h9zjet" />
          <p className="mt-4 max-w-[34ch] text-[15px] leading-relaxed text-ink-2" data-id="element-552" data-mp="5ayriofsjmbr">
            Learn 60+ languages from the language you already think in. Curriculum built with Loescher Editore.
          </p>
        </div>
        {groups.map(g => <nav key={g.title} aria-label={g.title} data-id="element-553" data-mp="26vx1rta5n61d">
            <h2 className="text-sm font-bold text-ink" data-id="element-554" data-mp="26xq8f8krpq9d">{g.title}</h2>
            <ul className="mt-3 space-y-2" data-id="element-555" data-mp="22ubq2b9cwxsr">
              {g.links.map(l => <li key={l.to} data-id="element-556" data-mp="2gtt9sc7spkv9">
                  <Link to={l.to} className="focus-ring group inline-flex rounded-md text-[15px] text-ink-2 hover:text-ink" data-id="element-557" data-mp="2gt1nxt4031i6">
                    <motion.span whileHover={{
                x: 3
              }} transition={spring.snappy} className="inline-block" data-id="element-558" data-mp="2bt5l3x71hg47">
                      {l.label}
                    </motion.span>
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>
      <div className="border-t-3 border-line" data-id="element-559" data-mp="2zldsmmi4mevh">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-5 text-sm text-ink-2 md:flex-row md:justify-between md:px-8" data-id="element-560" data-mp="2um147xblwzqs">
          <span data-id="element-561" data-mp="1s9morgnxea0i">© 2026 PolyLexa</span>
          <span data-id="element-562" data-mp="1s6id5y84sbzt">Made for curious people in many languages.</span>
        </div>
      </div>
    </footer>;
}